export default function WhyChooseUs() {
  const features = [
    {
      icon: 'ri-pencil-ruler-line',
      title: 'Design-Build Expertise',
      description: 'Seamless process from concept to completion with our in-house design and installation team.'
    },
    {
      icon: 'ri-vip-diamond-line',
      title: 'Premium Materials Only',
      description: 'We source the finest materials from trusted suppliers to ensure lasting beauty and durability.'
    },
    {
      icon: 'ri-shield-star-line',
      title: 'Lifetime Craftsmanship Warranty',
      description: 'Our work is backed by an industry-leading warranty because we build to last.'
    }
  ];

  return (
    <section className="relative py-24 overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Panel */}
          <div className="bg-[#2C2C2C] rounded-3xl p-12 lg:p-16 relative">
            <div className="absolute top-0 left-0 w-32 h-32 bg-[#E67E22]/10 rounded-full blur-3xl"></div>
            <blockquote className="text-4xl lg:text-5xl font-bold text-white leading-tight mb-8 relative z-10">
              "We don't just install landscapes. We craft outdoor living experiences."
            </blockquote>
            <div className="text-[#E67E22] font-semibold text-lg mb-12">
              — Michael, Founder
            </div>

            <div className="space-y-8">
              {features.map((feature, index) => (
                <div key={index} className="flex gap-6">
                  <div className="flex-shrink-0">
                    <div className="w-14 h-14 rounded-full bg-[#E67E22] flex items-center justify-center">
                      <i className={`${feature.icon} text-2xl text-white`}></i>
                    </div>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-white mb-2">{feature.title}</h3>
                    <p className="text-gray-400 leading-relaxed">{feature.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right Panel */}
          <div className="relative">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/2c248f68908d1bac099a95d6cb5b0917.jpg"
                alt="ScapeWorx team at work"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute bottom-8 right-8 bg-white rounded-2xl px-8 py-6 shadow-xl">
              <div className="text-4xl font-bold text-[#E67E22] mb-1">200+</div>
              <div className="text-sm font-semibold text-gray-900 whitespace-nowrap">5-Star Reviews</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}